<template>
  <div class="solutionThumbnail" @click="handleThumbnailClick()">
    <div class="thumbnailContainer pa-2 selectionView">
      <div class="d-flex justify-center">
        <img
          v-if="isThumbnailAvailable && displayThumbnail"
          class="thumbnailImage"
          :class="{ selected: isSelected }"
          :src="displayThumbnail"
          @error="onErrorImage"
          @load="isValidImage = true"
        />
        <div v-else class="thumbnailPlaceholder" :class="{ selected: isSelected }"
          >Thumbnail Unavailable</div
        >
      </div>
    </div>
  </div>
</template>

<script>
import DomainService from 'domain-service'
export default {
  props: {
    thumbnail: {
      type: Object,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isReviewing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValidImage: false,
      isThumbnailAvailable: true,
      isThumbnailClicked: false,
      displayThumbnail: undefined,
      reloadImageCount: 1,
    }
  },
  beforeMount() {
    this.displayThumbnail = this.getTemplateThumbnailPath(this.thumbnail.url)
  },
  methods: {
    handleThumbnailClick() {
      if (this.isReviewing) return
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-solution_thumbnail_${this.thumbnail.campaignSolutionId}-click`,
      })
      this.isThumbnailClicked = true
      this.$emit('handle-thumbnail-click', this.thumbnail.campaignSolutionId)
    },
    onErrorImage() {
      this.isThumbnailAvailable = false
      if (this.reloadImageCount > 3) return

      this.reloadImageCount++
      setTimeout(() => {
        this.isThumbnailAvailable = true
      }, 1000)
    },
    getTemplateThumbnailPath(url) {
      return DomainService.decorateWithContentServerDomain`${url}?${new Date().getTime()}`
    },
  },
}
</script>

<style lang="scss" scoped>
.solutionThumbnail {
  display: flex;

  .thumbnailContainer {
    margin: 0 5px;
    transition: transform 0.1s ease-in-out, border 0.1s ease-in-out;
    place-items: center;

    &.selectionView {
      cursor: pointer;
      &:hover {
        transform: scale(1.03);

        img {
          border: solid 1px #ee44aa;
          &.selected {
            border: solid 4px orange;
          }
        }
      }
    }

    img {
      max-width: 100%;
      height: auto;
      &.selected {
        border: solid 4px orange;
      }
    }

    .thumbnailPlaceholder {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid black;
      background-color: white;
      padding: 10px;
    }
  }
}
</style>
